import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { Wallet } from "lucide-react";
import { rp } from "./lemburUtil";

export default function LemburBudgetBar({ tahun, lokasi, refreshKey }) {
  const [a, setA] = useState(null);
  const yr = String(tahun || new Date().getFullYear()).slice(0, 4);
  useEffect(() => {
    const params = { tahun: yr };
    if (lokasi && lokasi !== "all") params.lokasi = lokasi;
    api.get("/lembur/anggaran", { params }).then((r) => setA(r.data)).catch(() => {});
  }, [yr, lokasi, refreshKey]);
  if (!a) return null;

  if (!a.anggaran || a.anggaran <= 0) {
    return (
      <div className="rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2.5 text-xs text-slate-500" data-testid="lembur-budget-unset">
        Anggaran lembur tahunan belum diatur. Atur di tab <b>Pengaturan &amp; Upah</b> untuk memantau pemakaian.
      </div>
    );
  }

  const pct = Math.max(0, a.persentase);
  const barPct = Math.min(100, pct);
  const tone = pct >= 100 ? "rose" : pct >= 80 ? "amber" : "emerald";
  const barColor = { rose: "bg-rose-500", amber: "bg-amber-500", emerald: "bg-emerald-500" }[tone];
  const pctColor = { rose: "text-rose-600", amber: "text-amber-600", emerald: "text-emerald-600" }[tone];

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3.5" data-testid="lembur-budget-bar">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Wallet className="h-4 w-4 text-blue-600" />
          <span className="text-sm font-semibold text-slate-700">Anggaran Lembur {a.tahun}</span>
        </div>
        <span className={`text-sm font-extrabold ${pctColor}`} data-testid="lembur-budget-pct">{pct}%</span>
      </div>
      <div className="h-2.5 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full rounded-full ${barColor} transition-all`} style={{ width: `${barPct}%` }} />
      </div>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-0.5 text-xs">
        <span className="text-slate-500">Terpakai: <b className="text-slate-800">{rp(a.terpakai)}</b></span>
        <span className="text-slate-500">Anggaran: <b className="text-slate-800">{rp(a.anggaran)}</b></span>
        <span className={a.sisa < 0 ? "text-rose-600" : "text-emerald-600"}>Sisa: <b>{rp(a.sisa)}</b></span>
      </div>
    </div>
  );
}
